module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-screen"
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "ponce-logo",
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    class: !this.logoLoaded ? 'logo-bg' : 'logo-bg bg-spinner'
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-container"
  }, [_c('v-img', {
    staticClass: "logo",
    attrs: {
      "src": require('../../assets/logoPonce.png'),
      "width": "100%",
      "contain": ""
    },
    on: {
      "load": _vm.onLogoLoad
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-overlay"
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "ponce-title",
    attrs: {
      "xs4": ""
    }
  }, [_c('h3', [_vm._v("PONCE")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-473f2e25","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/LoadingScreen.vue
// module id = 1706
// module chunks = 0